module.exports = __webpack_public_path__ + "static/media/p10.64522294.webp";